import { reloadWhenSafe } from '@core/app-version/reload-when-safe.js';

import { t } from '../translations.js';
import { ErrorPanel } from './error-panel.js';

/**
 * Crash fallback for a chunk-load failure: the tab is running an older build
 * than the one deployed, and a code-split chunk it needed is gone. Rendered by
 * `AppCrashPanel` (the `Sentry.ErrorBoundary` fallback) while the automatic
 * recovery reload is pending, and as the way out if that reload was declined
 * in the browser's "Leave site?" dialog. Reload waits for any save still in
 * flight (`reloadWhenSafe`) and keeps the current URL.
 *
 * Named for its situation, like the other wrappers (`MeBootstrap`,
 * `SessionInvalidated`, `Conflict`); no `code` — a stale chunk is not an
 * anomaly worth a support reference.
 */
export function NewVersionPanel() {
  return (
    <ErrorPanel
      title={t.app.newVersion.title}
      description={t.app.newVersion.description}
      primaryAction={{
        label: t.app.newVersion.reload,
        onClick: () => reloadWhenSafe(),
      }}
      testId="app-new-version-panel"
    />
  );
}
